/* Vue & App Component */
import Vue from 'vue';
import App from '../App.vue';

/* Plugins */
import vuetify from './plugins/vuetify.js';
import VueSweetalert2 from 'vue-sweetalert2';

import './plugins/icons.js';

/* App modules */
import { router, routes } from './router';
import Store from './store';
import I18n from '../i18n';

Vue.prototype.$routes = routes;
Vue.config.productionTip = false;

// Confetti plugin
import VueConfetti from 'vue-confetti';

Vue.use(VueSweetalert2);
Vue.use(VueConfetti);

new Vue({
	render: h => h(App),
	router,
	store: Store,
	vuetify,
	i18n: I18n
}).$mount('#app');
